// You can write more code here

import { ButtonController } from '@/game/prefabs/GeneralUI/Buttons/ButtonController';

/* START OF COMPILED CODE */

export default class DefaultButton extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // buttonBacking
    const buttonBacking = scene.add.image(0, 0, 'default-button-confirm');
    buttonBacking.scaleX = 2;
    buttonBacking.scaleY = 2;
    this.add(buttonBacking);

    // buttonGuidance
    const buttonGuidance = scene.add.image(
      0,
      0,
      'default-button-confirm-guidance',
    );
    buttonGuidance.scaleX = 2;
    buttonGuidance.scaleY = 2;
    buttonGuidance.alpha = 0;
    buttonGuidance.alphaTopLeft = 0;
    buttonGuidance.alphaTopRight = 0;
    buttonGuidance.alphaBottomLeft = 0;
    buttonGuidance.alphaBottomRight = 0;
    this.add(buttonGuidance);

    // buttonLabel
    const buttonLabel = scene.add.bitmapText(0, 0, 'Aronui', 'Button');
    buttonLabel.setOrigin(0.5, 0.5);
    buttonLabel.tintTopLeft = 15130076;
    buttonLabel.tintTopRight = 15130076;
    buttonLabel.tintBottomLeft = 15130076;
    buttonLabel.tintBottomRight = 15130076;
    buttonLabel.text = 'Button';
    buttonLabel.fontSize = -14;
    this.add(buttonLabel);

    this.buttonBacking = buttonBacking;
    this.buttonGuidance = buttonGuidance;
    this.buttonLabel = buttonLabel;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    this._controller = new ButtonController({
      buttonBacking,
      buttonLabel,
      defaultTexture: 'default-button-confirm',
      hoverTexture: 'default-button-confirm-hover',
      submitTexture: 'default-button-confirm-hover',
      disabledTexture: 'default-button-disabled',
      buttonGuidance: this.buttonGuidance,
    });
    this.labelOrigin = new Phaser.Math.Vector2(buttonLabel.x, buttonLabel.y);
    /* END-USER-CTR-CODE */
  }

  private buttonBacking: Phaser.GameObjects.Image;
  private buttonGuidance: Phaser.GameObjects.Image;
  private buttonLabel: Phaser.GameObjects.BitmapText;
  public buttonText: string = 'Submit';

  /* START-USER-CODE */
  protected labelOrigin: Phaser.Math.Vector2;
  protected defaultButtonTexture: string = 'default-button-confirm';
  _controller: ButtonController;
  get controller() {
    return this._controller;
  }

  awake(): {
    button: Phaser.GameObjects.Image | Phaser.GameObjects.NineSlice;
    text: Phaser.GameObjects.BitmapText;
  } {
    const { buttonBacking, buttonLabel, buttonGuidance } = this;

    buttonLabel.setText(this.buttonText);
    buttonGuidance.setVisible(false);

    return { button: buttonBacking, text: buttonLabel };
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
